import React from 'react'
import { Paper, Grid, Typography, Box, Container } from '@mui/material'
import {Link} from "react-router-dom"
import { contactStyles, landingStyles } from '../../styles/landing';
import Footer from "./footer";
import { useSelector } from "react-redux"

const Contact = () => {
    const classes = contactStyles()
    const clases = landingStyles()
    const {arborists, isLoggedIn} = useSelector(({arboristLogin})=>arboristLogin)
  return (
    <section id="contact">
        {!isLoggedIn && <Grid container>
        <Grid item sm={12} xs={12} md={12}> 
          <Typography>
            <Box fontFamily="CormorantBoldItalic" className={clases.heading}>Contact Us</Box></Typography>
          </Grid> 
          </Grid>}
        <Paper sx={{backgroundColor:"#222222"}} square>
        <Container sx={{ py: 8 }}>
        <Grid container>
         <Grid item xs={12} md={6} lg={6} sm={12}>           
            <Link to="/" style={{textDecoration:"none"}}>
              <Typography variant="subtitle1"  style={{padding:50, color:"#fff"}}>
                thearborist@arborhawk.com
              </Typography> 
            </Link>            
            <Typography variant="subtitle1"  style={{paddingLeft:50, color:"#fff"}}>
             (888)-897-8010
            </Typography> 
            <Typography variant="subtitle1"  style={{paddingLeft:50 ,color:"#fff"}}>
             3 Germay Dr, Unit 4 #2848
            </Typography> 
            <Typography variant="subtitle1"  style={{paddingLeft:50, color:"#fff"}}>
              Wilmington, DE 19804
            </Typography> 
            </Grid>
            <Grid item xs={12} md={6} lg={6} sm={12}>
            <img src ="assets/images/img1.jpg" className={classes.contactImage}/> 
            </Grid>    
            </Grid> 
            </Container>
        </Paper>
        <Footer />
    </section>
  )
}

export default Contact